import { Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OngoingComplianceModel } from 'src/Models/OngoingComplianceModel';
import { AppConfig } from 'src/Services/app.config';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import * as FileSaver from 'file-saver';
import { EmailLoginService } from 'src/Services/emaillogin.service';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { FilterModel } from 'src/Models/filterModel';
import { SessionStorageService } from 'src/common/session-storage.service';

declare const PDFObject: any;

@Component({
  selector: 'app-download-quotes-and-proposal',
  templateUrl: './download-quotes-and-proposal.component.html',
  styleUrls: ['./download-quotes-and-proposal.component.css']
})
export class DownloadQuotesAndProposalComponent implements OnInit {
  isSubmit: boolean = false;
  userID: any;
  ClientInformationId: number;
  tokenKey: any;

  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  stateCode: any;
  isRecord1: boolean = false;
  quoteName: string;
  quoteNameTitle:string='';
  listofCompliance: OngoingComplianceModel[];
  listofMiscellaneous: OngoingComplianceModel[];
  complianceTotal: number = 0;
  baseUrl: string;
  appModel: any;

  isQuoteApproved: number = 0;
  dropdownListQuoteStatus = [];
  selectedItemsQuoteStatus = [];
  dropdownSettingsQuoteStatus = {};
  listOfQuoteStatusIds = [];
  quoteStatusId: number = 0;
  isQuoteSeen:boolean = false;

  priceQuoteId: number = 0;
  selectdUserDocument: string = '';
  pdfURl: string = '';
  pdfURlAdvisory:string='';
  pdfURlMarketentry:string='';
  pdfURlSolution:string='';
  pdfURlFinal:string='';
  pdfOrgionalName: string = '';
  pdfOrgionalNameAdvisory:string='';
  pdfOrgionalNameSolution:string='';
  pdfOrgionalNameMarketentry:string='';
  pdfOrgionalNameFinal:string='';

  isMarketEntry: boolean = false;
  advisoryQuotebtndisplay: boolean = false;
  solutionQuotebtndisplay: boolean = false;

  btnClickName: number = 1;
  FinalQuoteLink: any = '';
  FinalMarketEntryQuoteLink: any = '';
  FinalMarketEntryReport:any='';
  FinalAdvisoryServicesQuoteLink: any = '';
  FinalSolutionsQuoteLink: any = '';
  isCompliance: boolean = false;

  encyKeyfilterModel = new FilterModel();
  emailUserId: any = 0;
  emailPriceQuoteId: number = 0;
  rejectReason: string;
  TitleMsg: string;
  quoteName1: string;


  constructor(private readonly router: Router, 
    private readonly PricingQuotesMaster: PricingQuotesService, 
    private readonly titleService: Title, 
    private readonly emailLoginService: EmailLoginService, 
    private readonly activedRoute: ActivatedRoute, 
    private readonly toastr: ToastrService, 
    private readonly htmlToPdf: HtmlToPdf,
    private readonly appActivity: ApplicationActivityService,
    @Inject('BASE_URL') baseUrl: string,
    private sessionStorageService: SessionStorageService) {
    this.userID = sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.baseUrl = baseUrl;
    this.titleService.setTitle('Price Quote | JSi360');

    this.dropdownSettingsQuoteStatus = {
      singleSelection: true,
      text: "Please Select Quote Status",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Quote Status available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };
  }

  ngOnInit() {
    this.isSubmit = false;
    this.activedRoute.params.subscribe((params: Params) => {

      if (params['id']) {
        if (params['id'] != null) {
          const value = params['id'];
          if (this.isNumber(value)) {
            this.ClientInformationId = params['id'];
            this.priceQuoteId = params['id'];
            this.GetAdvisorysolutionbuttonDataById(this.priceQuoteId);
            this.GetComplianceByClientInformationId(this.ClientInformationId);
          } else {
            this.encyKeyfilterModel.emailKey = params['id'];
            this.IsValidPriceQuoteEmailKey();
          }

          this.emailPriceQuoteId = +sessionStorage.getItem('emailPriceQuoteId');
          
        }
        this.GetQuoteStatusData(this.priceQuoteId);
        if(!this.isQuoteSeen || this.isQuoteSeen==null)
        this.priceQuoteSeen();
      }
    });

    ApplicationActivityStore('View', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], '/View/download-quotes-and-proposal/'+this.priceQuoteId);
  }
  
  IsValidPriceQuoteEmailKey() {
    this.emailLoginService.isValidPriceQuoteEmailKey(this.encyKeyfilterModel).subscribe(
      data => {
        this.priceQuoteId = data.priceQuoteId;
        this.emailUserId = data.userId;
        this.ClientInformationId = data.priceQuoteId;
        let IsAdmin = false;
        if (localStorage.getItem('clientTypeId') != null) {
          IsAdmin = localStorage.getItem('clientTypeId') == '2' ? true : false;
        }
        if (this.emailUserId.toString() !== this.userID.toString() && !IsAdmin)
          this.router.navigate(['/Access/Denied/PriceQuote']);
        else {
        this.GetQuoteStatusData(this.priceQuoteId);
          this.GetAdvisorysolutionbuttonDataById(this.priceQuoteId);
          this.GetComplianceByClientInformationId(this.ClientInformationId);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  GetQuoteStatusData(priceQuoteId: number) {
    this.PricingQuotesMaster.GetQuoteStatus(this.tokenKey, priceQuoteId).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.isQuoteApproved = result['quoteStatusData'].isQuoteApproved,
            this.isQuoteApproved = result['quoteStatusData'].isQuoteApproved;
            this.isQuoteSeen = result['quoteStatusData'].isQuoteSeen;
            this.quoteName1 = result['quoteStatusData'].quoteName;
        }
      });
  }

  GetComplianceByClientInformationId(ClientInformationId) {
    this.PricingQuotesMaster.GetProposelByClientInformationId(this.tokenKey, ClientInformationId).subscribe(
      data => {
        if (data['status'] = 'Success') {
          // this.globle.cApp.statusModel.isProposalDetailsCompleted = true;
          this.unblockDocument();
          if (data['compliance'] != null && data['compliance'].length > 0) {
            this.listofCompliance = data['compliance'].filter(x => x.totalMonthlyCost != 0);
            if (this.listofCompliance.length > 0)
              this.isCompliance = true;
          }

          if (data['marketEntryData'] != null && data['marketEntryData'].length > 0) {
            this.isMarketEntry = true;
          }
          else {
            this.isMarketEntry = false;
          }

          if (data['miscelleneous'] != null && data['miscelleneous'].length > 0) {
            this.listofMiscellaneous = data['miscelleneous'].filter(x => x.totalMonthlyCost != 0);
          }


          if (this.listofCompliance != null) {
            if (this.listofCompliance.length == 0) {
              this.isRecord1 = true;
            }
            else {

              if (this.listofCompliance[0].quoteName != null && this.listofCompliance[0].quoteName != "") {
                this.quoteName = " - " + this.listofCompliance[0].quoteName;
                this.quoteNameTitle = this.listofCompliance[0].quoteName;
              }
              else {
                this.quoteName = "";
                this.quoteNameTitle="";
              }
              for (let iCounter = 0; iCounter < this.listofCompliance.length; iCounter++) {
                this.complianceTotal = this.complianceTotal + this.listofCompliance[iCounter].totalMonthlyCost;
              }
            }
          }
          else {
            this.isRecord1 = false;
          }

          if (this.listofMiscellaneous != null) {
            if (this.listofMiscellaneous.length == 0) {
              this.isRecord1 = true;
            }
            else {
              this.isRecord1 = false;
            }
          }
        }
        else {
          this.unblockDocument();
          this.isRecord1 = false;
        }

        if (this.isCompliance == true) {
          this.createMyPdf1();
          this.isRecord1 = false;
          return;
        }
        else if (this.isMarketEntry == true) {
          this.createMatrketEntryPdf();
          this.isRecord1 = false;
          return;
        }
        else if (this.advisoryQuotebtndisplay == true) {
          this.createAdvisoryPdf();
          this.isRecord1 = false;
          return;
        }
        else if (this.solutionQuotebtndisplay == true) {
          this.createSolutionPdf();
          this.isRecord1 = false;
          return;
        }
        else {
          return;
        }

      }, error => { this.stateCode = error }
    );
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  createMyPdf1() {
     ApplicationActivityStore('View', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Final Quote :'+this.priceQuoteId);
    this.blockDocument();
    
    this.PricingQuotesMaster.GenerateProposalV2(this.priceQuoteId, this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.pdfURlFinal = data['url'];
          this.pdfURl = this.pdfURlFinal;
          this.pdfOrgionalNameFinal = data['fileName'];
          this.pdfOrgionalName = this.pdfOrgionalNameFinal;
          this.handleRenderPdf(data['url'])
          this.unblockDocument();
          this.FinalQuoteLink = this.selectdUserDocument;
        }
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  handleRenderPdf(data) {
    this.selectdUserDocument = data;
  }

  public downloadFile(filename: any, url: any, orignalFileName: any) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        sessionStorage.setItem('fileloading', 'false');
        this.htmlToPdf.DeletePDF(this.tokenKey, orignalFileName).subscribe(
          data => {
            this.unblockDocument();
          },
        );
      }
    );
  }

  public downloadFile1(no:number) {
    if(no==1){
      ApplicationActivityStore('Download', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Final Quote :'+this.priceQuoteId);
    }
    else if(no==2){
      ApplicationActivityStore('Download', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Market Entry Quote :'+this.priceQuoteId);
    }
    else if(no==3){
      ApplicationActivityStore('Download', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Advisory Services Quote :'+this.priceQuoteId);
    }
    else if(no==4){
      ApplicationActivityStore('Download', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Solution Quote :'+this.priceQuoteId);
    }
    else if(no==5){
      ApplicationActivityStore('Download', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Market Entry Report :'+this.priceQuoteId);
    }
    
    this.blockDocument();
    this.htmlToPdf.downloadPdf(this.pdfURl).subscribe(
      (res) => {
        FileSaver.saveAs(res, this.pdfOrgionalName);
        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  GetAllCommonQuote(){
    this.btnClickName=1;
    this.blockDocument();
    if (this.FinalQuoteLink == '' || this.FinalQuoteLink == null || this.FinalQuoteLink == undefined) {
      this.GetComplianceByClientInformationId(this.priceQuoteId);
    }
    else {
      this.selectdUserDocument = this.FinalQuoteLink;
      this.pdfURl = this.pdfURlFinal;
      this.pdfOrgionalName = this.pdfOrgionalNameFinal;
      this.unblockDocument();
    }
  }
  GetAdvisorysolutionbuttonDataById(priceQuoteId: number) {
    this.PricingQuotesMaster.GetAdvisorysoultionbuttondisplay(priceQuoteId, this.tokenKey,).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (result.lstdata[0].advisoryServices > 0) {
            this.advisoryQuotebtndisplay = true;
          }
          else {
            this.advisoryQuotebtndisplay = false;
          }

          if (result.lstdata[0].solutions > 0) {
            this.solutionQuotebtndisplay = true;
          }
          else {
            this.solutionQuotebtndisplay = false;
          }
        }
      });
  }

  createAdvisoryPdf() {
    ApplicationActivityStore('View', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Advisory Services :'+this.priceQuoteId);
    this.btnClickName=3;
    this.blockDocument();
    if (this.FinalAdvisoryServicesQuoteLink == null || this.FinalAdvisoryServicesQuoteLink == '' || this.FinalAdvisoryServicesQuoteLink == undefined) {
      this.PricingQuotesMaster.GenerateAdvisoryServicesQuote(this.priceQuoteId, "", this.tokenKey).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.pdfURlAdvisory=data['url'];
            this.pdfURl = this.pdfURlAdvisory;
            this.pdfOrgionalNameAdvisory = data['fileName'];
            this.pdfOrgionalName = this.pdfOrgionalNameAdvisory;
            this.handleRenderPdf(data['url'])
            this.FinalAdvisoryServicesQuoteLink = this.selectdUserDocument;
            this.unblockDocument();
          }
        },
        error => {
          this.unblockDocument();
        }
      );
    }
    else {
      this.selectdUserDocument = this.FinalAdvisoryServicesQuoteLink;
      this.pdfURl = this.pdfURlAdvisory;
      this.pdfOrgionalName = this.pdfOrgionalNameAdvisory;
      this.unblockDocument();
    }
  }

  createSolutionPdf() {
    ApplicationActivityStore('View', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Solution Quote :'+this.priceQuoteId);
    this.btnClickName=4;
    this.blockDocument();
    if(this.FinalSolutionsQuoteLink == null || this.FinalSolutionsQuoteLink == '' || this.FinalSolutionsQuoteLink == undefined){
       this.PricingQuotesMaster.GenerateSolutionServicesQuote(this.priceQuoteId,"",this.tokenKey).subscribe(
         data => {
           if (data['status'] == 'Success') {
             this.pdfURlSolution = data['url'];
             this.pdfURl = this.pdfURlSolution;
             this.pdfOrgionalNameSolution = data['fileName'];
             this.pdfOrgionalName = this.pdfOrgionalNameSolution;
             //this.downloadFile('SolutionsProposal.pdf', data['url'], data['fileName']);
             this.handleRenderPdf(data['url']);
             this.FinalSolutionsQuoteLink = this.selectdUserDocument;
             this.unblockDocument();
           }
         },
         error => {
           this.unblockDocument();
         }
       );
    }
    else {
      this.selectdUserDocument = this.FinalSolutionsQuoteLink;
      this.pdfURl = this.pdfURlSolution;
      this.pdfOrgionalName = this.pdfOrgionalNameSolution;
      this.unblockDocument();
    }
  }

  createMatrketEntryPdf() {
    ApplicationActivityStore('View', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Market Entry Quote :'+this.priceQuoteId);
    this.btnClickName=2;
    this.blockDocument();
    if (this.FinalMarketEntryQuoteLink == null || this.FinalMarketEntryQuoteLink == '' || this.FinalMarketEntryQuoteLink == undefined) {
      this.PricingQuotesMaster.GenerateMarketEntryPDF(this.priceQuoteId, "", this.tokenKey).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.pdfURlMarketentry = data['url'];
            this.pdfURl=this.pdfURlMarketentry;
            this.pdfOrgionalNameMarketentry = data['fileName'];
            this.pdfOrgionalName = this.pdfOrgionalNameMarketentry;
            this.handleRenderPdf(data['url']);
            this.FinalMarketEntryQuoteLink = this.selectdUserDocument;
            this.unblockDocument();
          }
        },
        error => {
          this.unblockDocument();
        }
      );
   }
   else
   {
     this.selectdUserDocument = this.FinalMarketEntryQuoteLink;
     this.pdfURl=this.pdfURlMarketentry;
     this.pdfOrgionalName = this.pdfOrgionalNameMarketentry;
     this.unblockDocument();
   }
  }

  isNumber(value: any): boolean {
    const regex = /^\d+$/;
    return regex.test(value);
  }

  priceQuoteSeen() {
    this.blockDocument();
    this.PricingQuotesMaster.UpdateQuoteMarkAsSeen(this.tokenKey, this.emailPriceQuoteId).subscribe(
      data => {
        this.unblockDocument();
        if (data['status'] == 'Success') {
         
        }
        this.unblockDocument();
      },
      error => { }
    );

  }

  onStatusChange(priceQuoteId, isQuoteApproved) {
    this.isSubmit = false;
    this.quoteStatusId = isQuoteApproved;
    this.rejectReason = "";
    if (isQuoteApproved == 2) {
      this.TitleMsg = "Approve"
    }
    else {
      this.TitleMsg = "Reject";
    }
    this.priceQuoteId = priceQuoteId;
    document.getElementById("btnopenApprovedpopup").click();
    return;
  }

  onStatusReject(priceQuoteId, isQuoteApproved) {
    this.isSubmit = false;
    this.quoteStatusId = isQuoteApproved;
    this.priceQuoteId = priceQuoteId;
    var PriceQuoteData1 = this.dropdownListQuoteStatus.filter(x => x.id == isQuoteApproved)[0];
    if (PriceQuoteData1 != null) {
      this.selectedItemsQuoteStatus = [];
      this.quoteStatusId = PriceQuoteData1.id;
      this.selectedItemsQuoteStatus.push({ "id": PriceQuoteData1.id, "itemName": PriceQuoteData1.itemName })
    }
    document.getElementById("btnopenRejectpopup").click();
    return;
  }

  priceQuoteApproved() {
    this.isSubmit = true;

    this.isQuoteApproved = this.quoteStatusId;
    if (this.quoteStatusId == 3) {
      if (this.rejectReason == "" || this.rejectReason == null) {
        return;
      }
    }

    ApplicationActivityStore('Click Link', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], this.quoteName1 +" - "+this.TitleMsg);
    document.getElementById("closebutton").click();

    this.blockDocument();
    this.PricingQuotesMaster.PriceQuoteApproved(this.tokenKey, this.priceQuoteId, this.quoteStatusId, this.rejectReason,this.userID).subscribe(
      data => {
        this.unblockDocument();
        if (data['status'] == 'Success') {
          this.isSubmit = false;
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else {
            this.showMessage("Quote Status update successfully", 'Success', 'success')
          }
        }

      },
      
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }
  GenerateMarketEntryReportPDF() {
    ApplicationActivityStore('View', 'Price Quote', this.appActivity, ToolEnum.PricingQuote, ActionActivity['PricingQuote'], 'Market Entry Report :'+this.priceQuoteId);
    this.btnClickName=5;
    this.blockDocument();
    if(this.FinalMarketEntryReport == null || this.FinalMarketEntryReport == '' || this.FinalMarketEntryReport == undefined){
      this.PricingQuotesMaster.GenerateMarketEntryReportPDF(this.priceQuoteId,this.tokenKey).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.pdfURl = data['url'];
            this.pdfOrgionalName = data['fileName'];
            this.handleRenderPdf(data['url']);
            this.FinalMarketEntryReport = this.selectdUserDocument;
            this.unblockDocument();
          }
        },
        error => {
          this.unblockDocument();
        }
      );
   }
   else
   {
     this.selectdUserDocument = this.FinalMarketEntryQuoteLink;
     this.pdfURl=this.pdfURlMarketentry;
     this.pdfOrgionalName = this.pdfOrgionalNameMarketentry;
     this.unblockDocument();
   }
  }

}
